import { FormEventHandler, useState } from 'react';
import qs from 'qs';
import fetchAPI from 'app/helpers/fetch';
import { FormContext } from './useFormContext';

const useForm = (context: FormContext): [boolean, FormEventHandler<HTMLFormElement>, boolean, string] => {
  const { url, currencies } = context;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const isAvailable = !!currencies.length;

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    if (isSubmitted) return;

    setIsSubmitted(true);

    const formData = new FormData(e.target as HTMLFormElement);
    const params = qs.parse(Object.fromEntries(formData) as Record<string, string>);

    fetchAPI(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).catch((err: string) => {
      setError(err);
      setIsSubmitted(false);
    });
  };

  return [isAvailable, handleSubmit, isSubmitted, error];
};

export default useForm;
